import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const PrivacyPage = () => {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "プライバシーポリシー | TOUAREG GLOBAL",
      "description": "株式会社ミションのプライバシーポリシー。個人情報の取り扱いについて詳しく説明しています。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/privacy`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "TOUAREG GLOBAL",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
      },
      "publisher": {
        "@type": "Organization",
        "name": "株式会社ミション"
      },
      "dateModified": "2025-01-01",
      "inLanguage": "ja"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
              プライバシーポリシー
            </h1>
            
            <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
              <div>
                <p className="text-gray-600 mb-6">
                  株式会社ミション（以下「当社」といいます。）は、お客様の個人情報の保護に関して、以下のとおりプライバシーポリシーを定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。
                </p>
              </div>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. 個人情報の管理</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. 個人情報の利用目的</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電子メールや資料のご送付に利用いたします。具体的には以下の目的で利用いたします：
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>投資・資産管理サービスの提供</li>
                  <li>お客様からのお問い合わせへの対応</li>
                  <li>サービスに関する重要なお知らせの送付</li>
                  <li>新サービスや商品のご案内</li>
                  <li>アフターサービス、メンテナンスのご案内</li>
                  <li>各種セミナーやイベントのご案内</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. 個人情報の第三者への開示・提供の禁止</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 mt-4">
                  <li>お客さまの同意がある場合</li>
                  <li>お客さまが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合</li>
                  <li>法令に基づき開示することが必要である場合</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. 個人情報の安全対策</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。また、当社は個人情報の取扱いに関し、従業員全員に対し適切な監督をおこない、安全管理を徹底しております。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. ご本人の照会</h2>
                <p className="text-gray-600 leading-relaxed">
                  お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. 法令、規範の遵守と見直し</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Cookieについて</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社のウェブサイトでは、お客様により良いサービスを提供するため、Cookieを使用することがあります。Cookieは、お客様のブラウザに保存される小さなデータファイルで、お客様の利便性向上のために使用されます。お客様はブラウザの設定によりCookieの受け入れを拒否することができますが、その場合、ウェブサイトの一部機能がご利用いただけない場合があります。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. お問い合せ</h2>
                <div className="text-gray-600 leading-relaxed">
                  <p className="mb-4">
                    当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="font-semibold text-gray-900 mb-3">株式会社ミション</h3>
                    <div className="space-y-2">
                      <p><strong>所在地：</strong>〒610-0121 京都府城陽市寺田北山田26-7-401</p>
                      <p><strong>電話番号：</strong>090-3677-1000</p>
                      <p><strong>メールアドレス：</strong>touaregglobal@gmail.com</p>
                      <p><strong>受付時間：</strong>平日 9:00-18:00</p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <div className="text-center pt-8 border-t border-gray-200">
                  <p className="text-gray-600">
                    制定日：2025年1月1日<br />
                    最終更新日：2025年1月1日
                  </p>
                  <p className="text-gray-900 font-semibold mt-4">
                    株式会社ミション<br />
                    代表取締役 福井秀延
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
